import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams, useHistory } from 'react-router-dom';
import { NAME_SPACE } from 'i18n';
import { FormPage, useRequestLoading, ButtonBack, ButtonDownloadFile, useAzureStorage, domHelper } from 'shared';
import { CONTAINERS } from 'pages/shared';
import { PATH } from 'app.routes.const';
import { FormReaderRequest } from './FormReaderRequest';
import { useReaderRequest } from './useReaderRequest';

export function EditReaderRequest() {
  const { id } = useParams();
  const { readerRequest, errorInfo } = useReaderRequest(id);
  const { t } = useTranslation(NAME_SPACE.READER_REQUESTS);
  const { getReadSasToken } = useAzureStorage(CONTAINERS.READER_REQUESTS);
  const $formRef = useRef(null);
  const history = useHistory();
  const { requestLoading } = useRequestLoading();

  async function handleSubmit() {}

  function handleGoBack() {
    history.push(PATH.READER_REQUESTS.LIST);
  }

  async function handleDownload(responseFileUrl) {
    if (responseFileUrl) {
      const token = await getReadSasToken();
      const downloadUrl = responseFileUrl + '?' + token;
      domHelper.downloadFile(downloadUrl, responseFileUrl.replace(' ', '_'));
    }
  }

  function composeActionButtons() {
    const actionButtons = [
      { onClick: handleGoBack, component: ButtonBack },
      ...(readerRequest?.responseFileUrl
        ? [
            {
              text: t('actions.download'),
              onClick: () => handleDownload(readerRequest?.responseFileUrl),
              component: ButtonDownloadFile
            }
          ]
        : [])
    ];
    return actionButtons;
  }

  return (
    <FormPage
      title={t('singularName')}
      disabled={requestLoading}
      buttons={composeActionButtons()}
      onSubmit={handleSubmit}
    >
      <FormReaderRequest errors={errorInfo} formRef={$formRef} readerRequest={{ ...readerRequest }} />
    </FormPage>
  );
}
